import "../Styles/Footer.css";

export const Footer = ()=>{
    return <div className="footer">
        <p>Made with  <span className="heart">❤</span> by Aditya | © Aditya Kumar</p>
    </div>
}